export const SEARCH_EMPTY = 'empty' as const
export const SEARCH_HAS_RESULTS = 'has-results' as const
export const SEARCH_NO_RESULTS = 'no-results' as const

export const THUMBNAIL_WIDTHS = [92, 103, 184, 206]
export const THUMBNAIL_TRANSFORMS = {
  width: 184,
  height: 184,
  quality: 80,
  ratio: '1/1',
  format: 'jpg',
} as const

export const HITS_PER_PAGE = 36 as const

export const FILTERS_PAGE_TYPE: Record<string, string> = {
  recipes: '_type:page.recipe',
  articles: '_type:page.blog',
  videos: '_type:page.videos',
}

export const INDEX_PAGES = 'pages' as const
export const INDEX_COLLECTIONS = 'collections' as const
export const INDEX_PAGES_SUGGESTIONS = 'pages_query_suggestions' as const

export const SEARCH_RESULT_ATTRIBUTES_FEATURE = [
  'title',
  'link.href',
  'copy',
  'image',
  '_type',
  '_id',
  'youtubeId',
  'price',
] as const
export const SEARCH_RESULT_ATTRIBUTES_SIMPLE = ['title', 'link.href', '_type', '_id'] as const
export const SEARCH_RESULT_ATTRIBUTES_SUGGESTIONS = ['query', 'pages.exact_nb_hits'] as const
